import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        activeList:{

        },
        es:{
            lang:'es',
            header:{ // Header.vue
                menu1: 'NOSOTROS',
                menu2: 'SERVICIOS',
                menu3: 'INFRAESTRUCTURA',
                menu4: 'DESTINOS',
                menu5: 'CLIENTES',
                menu6: 'CONTACTO',
                menu7: 'ES'
            },
            bannerHome:{ // Home.vue
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                bannerTextTop: 'ALTA CALIDAD',
                bannerTextBottom: 'Y SEGURIDAD',
                btnText: 'Conócenos'
            },
            historyHome:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'Empresa fundada en 1972 <br>en la ciudad de Mexicali, B.C.',
                pTextTop: 'Bajo la dirección del Sr. Jorge Arizona Corona y Sr. Pedro Lázaro Gutiérrez Gómez que con un gran visión de negocio desarrollaron un proyecto que facilitara las comunicaciones y los acarreos terrestes entre Estados Unidos de America y México.',
                pTextBottom: 'Empresa que hasta hoy se mantiene con gran fuerza en la región y que día a día sigue expandiéndose.',
                btnText: 'Ver Más'
            },
            servicesHome:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'Servicios Que Ofrecemos',
                pTextTop: 'En Transportes Santoyo, la confiabilidad de cada uno de nuestros servicios es una de las <br> más altas prioridades, para otorgar a nuestros clientes el servicio que se merecen.',
                serviceText1: 'Logística Internacional',
                serviceText2: 'Cruce Fronterizo',
                serviceText3: 'Monitoreo y rastreo<br>GPS de unidades',
                serviceText4: 'Entregas Urgentes',
                serviceText5: 'Transporte de mercancías',
                serviceText6: 'Entrega puerta a puerta<br>Estados Unidos y México',
                serviceText7: 'Choferes con licencia FAST',
                serviceText8: 'Almacén',
                titleFlotilla: 'Nuestra flotilla cuenta con:',
                flotilla: {
                    textFlotilla1: {
                        img: 'home_cajasecas',
                        texto: '200 cajas secas 53”'
                    },
                    textFlotilla2:{
                        img: 'home_plataforma',
                        texto: '15 plataforma 48”'
                    },
                    textFlotilla3:{
                        img: 'home_tanque',
                        texto: '90 tanques'
                    },
                    textFlotilla4:{
                        img: 'home_foodgrade',
                        texto: '5 tanques food grade'
                    },
                    textFlotilla5:{
                        img: 'home_tractocamion',
                        texto: '100 Tractocamiones'
                    },
                    textFlotilla6:{
                        img: 'home_cajasrefrigeradas',
                        texto: '5 Cajas refrigeradas'
                    },
                },
                btnVerMas: 'Ver Más'                
            },
            mapHome:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'Principales Destinos',
                pTextTop: 'Nuestros destinos principales son Washington, Oregon, Nevada, California, Arizona, Nuevo México y Texas sin embargo contamos con destinos en todo México.'
            },
             clientsHome:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'Nuestros Clientes'
            },
            contactPage:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'CONTÁCTANOS',
                subTitle1: '¿Tienes Dudas? Mándanos un mensaje',
                subTitle2: 'Ubícanos',
                btnSubmit: 'Enviar'
            },
            aboutUsMain:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle1: 'QUIENES SOMOS',
                subTitle2: 'Historia',
                paragraphText:'Empresa fundada en 1972 en la ciduad de Mexicali B.C. bajo la dirección del Sr. Jorge Arizona Corona y Sr. Pedro Lázaro Gutiérrez Gómez, que con un gran visión de negocio desarrollaron un proyecto que facilitará las comunicaciones y los acarreos terrestes entre Estados Unidos de América y México.<br><br>Empresa que hasta hoy se mantiene con gran fuerza en la región y que día a día sigue expandiéndose.',
                misionTitle:'Misión',
                misionText:'Brindar servicios transporte y logística de mercancías de alta calidad y seguridad a nuestros clientes a través de la eficiencia, eficacia y mejora continua día con día.',
                visionTitle:'Visión',
                visionText:'Consolidar a Transportes de Carga Santoyo S.A. de C.V. como el aliado predilecto en el sector transportista y de logística en la zona Noroeste de México y Estados Unidos.'
            },
            aboutUsOrg:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'Organización',
                bannerTextBottom: 'En Transportes Santoyo creemos en la especialización y capacitación, es por eso que hemos<br>logrado con los años un equipo de profesionales al servicio de cada uno de nuestros clientes.',
                imgTxt1: 'Dirección General',
                imgTxt2: 'Despacho',
                imgTxt3: 'Tráfico / Logística<br>Monitoreo GPS',
                imgTxt4: 'Contabilidad  ',
                imgTxt5: 'Operadores de viajes ',
                imgTxt6: 'Mecánica',
                imgTxt7: 'CTPAT',
                imgTxt8: 'Recursos Humanos',
                imgTxt9: 'Compras y Mantenimiento',
                imgTxt10: 'Administración y finanzas',
                imgTxt11: 'Almacén',
            },
            aboutUsValues:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle1: 'Valores',
                subTitle2: 'Honestidad',
                valueImgTxt1: 'Confiabilidad',
                valueImgTxt2: 'Responsabilidad',
                valueImgTxt3: 'Compromiso',
                valueImgTxt4: 'Innovación',
                valuesVideo: 'https://www.youtube.com/embed/JA1S7xBi5hg?rel=0&amp;showinfo=0'
            },
             servicesPage:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'SERVICIOS',
                pTextTop: 'En Transportes Santoyo, la confiabilidad de cada uno de nuestros servicios es una de las <br> más altas prioridades, para otorgar a nuestros clientes el servicio que se merecen.',
                serviceText1: 'Logística Internacional',
                serviceText2: 'Cruce Fronterizo',
                serviceText3: 'Monitoreo y rastreo<br>GPS de unidades',
                serviceText4: 'Entregas Urgentes',
                serviceText5: 'Transporte de mercancías',
                serviceText6: 'Entrega puerta a puerta<br>Estados Unidos y México',
                serviceText7: 'Choferes con licencia FAST',
                serviceText8: 'Almacén',
                // titleFlotilla: 'Nuestra flotilla cuenta con:',
                // textFlotilla1:'200 cajas secas 53”',
                // textFlotilla2:'15 plataforma 48',
                // textFlotilla3:'90 tanques',
                // textFlotilla4:'5 tanques food grade',
                // textFlotilla5:'100 Tractocamiones',
                // textFlotilla6:'5 Cajas refrigeradas',
                // btnVerMas: 'Ver Más',
                certTitle: 'Certificaciones'                
            },
            inventarioPage:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'INVENTARIO',
                imgInv1: 'inventario_cajasecas',
                imgInv2: 'inventario_foodgrade',
                imgInv3: 'inventario_plataforma',
                imgInv4: 'inventario_tanques',
                imgInv5: 'inventario_tractocamiones',
                imgInv6: 'inventario_cajasrefrigeradas',
            },
            mapDest:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                dubtitle1: 'DESTINOS',
                subTitle2: 'Principales Destinos',
                pTextTop: 'Nuestros destinos principales son Washington, Oregon, Nevada, California, Arizona, Nuevo México y Texas sin embargo contamos con destinos en todo México.'
            },
            clientsPage:{
                title: 'T R A N S P O R T E S &nbsp&nbsp  S A N T O Y O',
                subTitle: 'CLIENTES',
                clientTxt: 'En Transportes Santoyo tener una sólida relación con nuestros clientes es de suma importancia, es por ello que damos lo mejor de nosotros para brindar el mejor servicio de la región tanto en calidad, seguridad, así como en tiempo y forma de nuestras entregas.<br><br>Gracias a nuestros esfuerzos contamos con grandes alianzas que nos han llevado a ser una de las mejores empresas en nuestra área.'
            },
            footerPage:{
                title: 'CONTÁCTANOS',
                footerTxt: 'Todos Los Derechos Reservados'
            }

        },
         en:{
            lang:'en',
            header:{
                menu1: 'ABOUT US',
                menu2: 'SERVICES',
                menu3: 'INFRAESTRUCTURE',
                menu4: 'DESTINATIONS',
                menu5: 'CLIENTS',
                menu6: 'CONTACT US',
                menu7: 'EN'
            },
            bannerHome:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                bannerTextTop: 'HIGH QUALITY',
                bannerTextBottom: 'AND SECURITY',
                btnText: 'Know us'
            },
            historyHome:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'Business founded in 1972 <br>in the city of Mexicali, B.C.',
                pTextTop: 'Under the direction of Mr. Jorge Arizona Corona and Mr. Pedro Lazaro Gutierrez Gomez that with a great vision of business developed a project that would facilitate communications and terrestrial carryings between the United States of America and Mexico.',
                pTextBottom: 'Business that until today keeps itself with great force in the region and that day by day keeps spreading.',
                btnText: 'See More'
            },
            servicesHome:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'Offered Services',
                pTextTop: 'In Santoyo Transport, the reliability of each of our services is one of our highest priorities to offer our clients the service they deserve.',
                serviceText1: 'International Logistics',
                serviceText2: 'Border Crossing',
                serviceText3: 'Units Monitoring <br>and GPS Tracking',
                serviceText4: 'Urgent Deliveries',
                serviceText5: 'Merchandise Transport',
                serviceText6: 'Door-to-Door Delivery in<br>United States and Mexico',
                serviceText7: 'FAST License Chauffeurs',
                serviceText8: 'Warehouse',
                titleFlotilla: 'Our fleet counts with:',
                flotilla: {
                    textFlotilla1: {
                        img: 'home_cajasecas',
                        texto: '200 Dry Boxes 53”'
                    },
                    textFlotilla2:{
                        img: 'home_plataforma',
                        texto: '15 Platforms 48”'
                    },
                    textFlotilla3:{
                        img: 'home_tanque',
                        texto: '90 Tanks'
                    },
                    textFlotilla4:{
                        img: 'home_foodgrade',
                        texto: '5 Food Grade Tanks'
                    },
                    textFlotilla5:{
                        img: 'home_tractocamion',
                        texto: '100 Tractor Units'
                    },
                    textFlotilla6:{
                        img: 'home_cajasrefrigeradas',
                        texto: '5 Refrigerated Boxes'
                    },
                },
                btnVerMas: 'See More'                
            },
            mapHome:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'Principal Destinations',
                pTextTop: 'Our principal destinations are Washington, Oregon, Nevada, California, Arizona, New Mexico and Texas. Nevertheless, we count with destinations in all Mexico.'
            },
             clientsHome:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'Our Clients'
            },
            contactPage:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'Contact Us',
                subTitle1: 'Have any questions? Send us a message.',
                subTitle2: 'Locate Us',
                btnSubmit: 'Send',
                inputTxt1: 'Name',
                inputTxt2: 'Subject',
                inputTxt3: 'Message',
            },
            aboutUsMain:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle1: 'WHO ARE WE',
                subTitle2: 'History',
                paragraphText:'Under the direction of Mr. Jorge Arizona Corona and Mr. Pedro Lazaro Gutierrez Gomez that with a great vision of business developed a project that would facilitate communications and terrestrial carryings between the United States of America and Mexico.',
                misionTitle:'Mission',
                misionText:'Provide high quality transport and logistics of merchandise services and security to our clients through efficiency, effectiveness and continuous improvement day by day.',
                visionTitle:'Vision',
                visionText:'Consolidate Santoyo Transport as the preferred ally in the transports sector and logistics in the Northeast zone of Mexico and United States.'
            },
            aboutUsOrg:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'Organization',
                bannerTextBottom: 'In Santoyo Transport we believe in specialization and capacitation, that is why we have accomplished through the years a professional team ready to serve each one of our clients.',
                imgTxt1: 'General Management',
                imgTxt2: 'Dispatch',
                imgTxt3: 'Traffic / GPS <br>Logistic Monitoring',
                imgTxt4: 'Accountability  ',
                imgTxt5: 'Travel Operators ',
                imgTxt6: 'Mechanics',
                imgTxt7: 'CTPAT',
                imgTxt8: 'Human Resources',
                imgTxt9: 'Purchases and Maintenance',
                imgTxt10: 'Finance and Administration',
                imgTxt11: 'Warehouse',
            },
            aboutUsValues:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle1: 'Values',
                subTitle2: 'Honesty',
                valueImgTxt1: 'Trustfulness',
                valueImgTxt2: 'Responsibility',
                valueImgTxt3: 'Compromise',
                valueImgTxt4: 'Innovation',
                valuesVideo: 'https://www.youtube.com/embed/JA1S7xBi5hg?rel=0&amp;showinfo=0'
            },
             servicesPage:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'Offered Services',
                pTextTop: 'In Santoyo Transport, the reliability of each of our services is one of our highest priorities to offer our clients the service they deserve.',
                serviceText1: 'International Logistics',
                serviceText2: 'Border Crossing',
                serviceText3: 'Units Monitoring <br>and GPS Tracking',
                serviceText4: 'Urgent Deliveries',
                serviceText5: 'Merchandise Transport',
                serviceText6: 'Door-to-Door Delivery in<br>United States and Mexico',
                serviceText7: 'FAST License Chauffeurs',
                serviceText8: 'Warehouse',
                // titleFlotilla: 'Our fleet counts with:',
                // textFlotilla1:'200 Dry Boxes 53”',
                // textFlotilla2:'15 Platforms 48”',
                // textFlotilla3:'90 Tanks',
                // textFlotilla4:'5 Food Grade Tanks',
                // textFlotilla5:'100 Tractor Units',
                // textFlotilla6:'5 Refrigerated Boxes',
                // btnVerMas: 'See More',                
                certTitle: 'Certifications'                
            },
            inventarioPage:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'INVENTARIO',
                imgInv1: 'inventario_cajasecas',
                imgInv2: 'inventario_foodgrade',
                imgInv3: 'inventario_plataforma',
                imgInv4: 'inventario_tanques',
                imgInv5: 'inventario_tractocamiones',
                imgInv6: 'inventario_cajasrefrigeradas',
            },
            mapDest:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                dubtitle1: 'DESTINATIONS',
                subTitle2: 'Principal Destinations',
                pTextTop: 'Our principal destinations are Washington, Oregon, Nevada, California, Arizona, New Mexico and Texas. Nevertheless, we count with destinations in all Mexico.'
            },
            clientsPage:{
                title: 'S A N T O Y O &nbsp&nbsp  T R A N S P O R T',
                subTitle: 'CLIENTS',
                clientTxt: 'In Santoyo Transport, having a solid relationship with our clients is very important.. That is why we give the best of ourselves to provide the best service of the region regarding quality, security, as well as time and form of our deliveries.<br><br>Thanks to our effort we have built great alliances that have led us to become one of the best businesses in our area.'
            },
            footerPage:{
                title: 'CONTACT US',
                footerTxt: 'All rights reserved'
            }

        }
},
mutations: {
    toggleLang(state){
    if(state.activeList.lang === 'es' || !state.activeList.lang){
        state.activeList = state.en
    }else{
         state.activeList = state.es
    }
    }
}


})



// WEBPACK FOOTER //
// ./src/store/store.js